'use client'

import { useState } from 'react'
import { uppercaseFirstLetter } from '@utils/stringUtils'
import { FuelType } from '@helpers/fuelPageHelpers'
import styles from './majorCityFuelSection.module.scss'
import { DIESEL, PETROL } from '../FuelTableComponent/constants/texts'

const MajorCityFuelSection = ({ fuelValue, majorCities }) => {
  const [fuelType, setFuelType] = useState(
    fuelValue === FuelType.Fuel ? uppercaseFirstLetter(FuelType.Petrol) : uppercaseFirstLetter(fuelValue)
  )
  const handleClick = redirectionUrl => {
    window.open(redirectionUrl, '_blank')
  }

  const majorCitiesArray = (majorCities || '').split(',')

  return (
    <div className={styles.majorCitiesContainer}>
      <div className={styles.majorCitiesTitle}>{`${fuelType} price in other major cities`}</div>
      <div className={styles.selectFuelTypeForCities}>
        <div
          onClick={() => setFuelType(uppercaseFirstLetter(FuelType.Petrol))}
          className={`${styles.fuelName} ${fuelType === uppercaseFirstLetter(FuelType.Petrol) && styles.currentFuel}`}>
          {PETROL}
        </div>
        <div
          onClick={() => setFuelType(uppercaseFirstLetter(FuelType.Diesel))}
          className={`${styles.fuelName} ${fuelType === uppercaseFirstLetter(FuelType.Diesel) && styles.currentFuel}`}>
          {DIESEL}
        </div>
      </div>
      <div className={styles.majorCitiesUlTag}>
        {majorCitiesArray.map((majorCity, index) => (
          <div
            className={styles.majorCitiesLiTag}
            key={`${majorCity}${index}`}
            onClick={e => {
              handleClick(
                `/fuel/${fuelType.toLowerCase()}-price-in-${majorCity.toLowerCase().trim().replace(/\s/g, '-')}/`
              )
            }}>
            <div className={styles.clickableCity}>{`${fuelType} price in ${majorCity}`}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default MajorCityFuelSection
